import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import Menu from "../entities/pdv/menu.entity";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class MenuDB extends FirestorePipe {

  public static readonly colName = 'Menus'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${MenuDB.colName}`);
  }

  public create(data: Menu): Promise<any> {
    return this._create(data);
  }
  public update(id: string, data: Menu): Promise<any> {
    return this._update(id, data);
  }
  public delete(id: string): Promise<any> {
    return this._delete(id);
  }
  public getAll(...params: QueryConstraint[]): Promise<Menu[]> {
    return this._getAll<Menu>(...params);
  }
  public get(id: string): Promise<Menu> {
    return this._get(id);
  }
  public on(listener: (data: Menu[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }

}

export default MenuDB;